export default {
    namespaced: true,
    state: {
        list: [
            {
                label: 'Полностью',
                value: 1,
            },
            {
                label: 'Частично',
                value: 2,
            },
            {
                label: 'Неоплаченные',
                value: 3,
            },
        ],
        load: false,
    },
    actions:{
        get_list(){},
    },
    getters: {
        list: (state, getters, rootState, rootGetters) => {
            return state.list;
        },
    }
}